import {Component, OnInit} from '@angular/core';
import {DatasetService} from '../../../provider/dataset.service';

@Component({
  selector: 'kt-analysis',
  template: '<router-outlet></router-outlet>'
})
export class AnalysisPage implements OnInit {

  constructor(private datasetService: DatasetService) {
    this.datasetService.getData();
  }

  ngOnInit() {
  }

}
